import React from 'react'

const list = props => {

  const cashTotal = props.cashList.reduce((total, data) => total + parseInt(data.amount), 0);
  const receivableTotal = props.receivableList.reduce((total, data) => total + parseInt(data.amount), 0);
  const payableTotal = props.payableList.reduce((total, data) => total + parseInt(data.amount), 0);

  return (
    <table>
      <tbody>
        <tr key="01">
          <th>Cash</th>
          <th>Receivable</th>
          <th>Payable</th>
          <th>Balance</th>
        </tr>
        <tr key="02">
          <td>{cashTotal}</td>
          <td>{receivableTotal}</td>
          <td>{payableTotal}</td>
          <td>{cashTotal+receivableTotal-payableTotal}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default list;



// WEBPACK FOOTER //
// ./src/components/Summary/list.js